/**
 * Shared pay configuration types for API contracts between frontend and backend
 * PayConfiguration represents template pay configs for cost estimates (not employee-specific)
 */
import { z } from "zod";
import { uuidSchema } from "./validation-common.js";
// Enum Zod schemas
export const CompensationTypeSchema = z.enum(["SALARIED", "HOURLY"]);
export const PaymentTypeSchema = z.enum(["DAILY", "WEEKLY", "EVERY_OTHER_WEEK", "BIMONTHLY"]);
export const LaborLawClassificationSchema = z.enum(["EXEMPT", "NON_EXEMPT"]);
// Zod schema for creating a pay configuration (for job role or shift override)
// Note: jobRoleFamilyId pay configs are auto-generated, not created via API
export const CreatePayConfigurationInputSchema = z.object({
    compensationType: CompensationTypeSchema,
    paymentType: PaymentTypeSchema,
    laborLawClassification: LaborLawClassificationSchema,
    minimumPay: z.number().nonnegative(),
    maximumPay: z.number().positive(),
    tipEligible: z.boolean(),
    overtimeRate: z.number().nonnegative(),
    commissionEligible: z.boolean(),
    jobRoleId: uuidSchema.optional(), // For default config
    shiftId: uuidSchema.optional(), // For shift override
}).refine((data) => data.maximumPay >= data.minimumPay, { message: "Maximum pay must be greater than or equal to minimum pay", path: ["maximumPay"] });
// Response schema for API output validation
export const PayConfigurationResponseSchema = z.object({
    id: z.uuid(),
    compensationType: CompensationTypeSchema,
    paymentType: PaymentTypeSchema,
    laborLawClassification: LaborLawClassificationSchema,
    minimumPay: z.number(),
    maximumPay: z.number(),
    tipEligible: z.boolean(),
    overtimeRate: z.number(),
    commissionEligible: z.boolean(),
    jobRoleId: z.uuid().optional(),
    shiftId: z.uuid().optional(),
    jobRoleFamilyId: z.uuid().optional(),
    createdAt: z.iso.datetime(),
    updatedAt: z.iso.datetime(),
});
